// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SubV","tabsBox":"styles_tabsBox__3-bhw","createButton":"styles_createButton__2DHHo"};